import { onMounted, onUnmounted, ref } from 'vue'

const SECOND = 1000
const TICK = SECOND

export function useActiveNSec(targetSeconds: number, callback: () => void) {
    const intervalRef = ref<ReturnType<typeof setInterval>>()
    const ticks = ref(0)
    const targetTicks = targetSeconds * SECOND

    const intervalTick = () => {
        if (document.hidden) {
            return
        }

        ticks.value += TICK

        if (ticks.value >= targetTicks) {
            callback()
            clearInterval(intervalRef.value)
            intervalRef.value = undefined
        }
    }

    onMounted(() => {
        intervalRef.value = setInterval(intervalTick, TICK)
    })

    onUnmounted(() => {
        clearInterval(intervalRef.value)
    })
}
